import apiManagerUser from 'api/manager-users';
import { useDialog } from 'components/DialogV3';
import DialogAcceptPolicy from 'components/DialogV3/DialogAcceptPolicy';
import LanguageCC from 'components/Layout/LanguageCC';
import { PATH_ROOT, URL_LANDING_PAGE } from 'constants/api';
import { TOAST_DEFAULT } from 'constants/toast';
import { AppInfo, FooterAuthentication } from 'layouts';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { establishSession } from 'store/sessionSlice';
import { randomColorFunc } from 'utils/functions';
import { toastError, toastSuccess } from 'utils/helpers';
import OTPRegister from '../components/OTPRegister';
import RegisterEmailNoSSO from '../components/RegisterEmailNoSSO';
import RegisterEmailSameSSO from '../components/RegisterEmailSameSSO';
import { ERROR } from '../components/constant';
import './index.css';
import { useAuthFlow } from '../AuthFlowContext';

const COMPONENT_RENDER = {
    OTP: 1,
    REGISTER_EMAIL_NO_SSO: 2,
    REGISTER_EMAIL_SAME_SSO: 3
}

export default function VerifyEmail() {
    const { componentRender } = useParams();
    const [otp, setOtp] = useState('');
    const [params, setSearchParams] = useSearchParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { registration, updateRegistrationFlow, clearRegistrationFlow } = useAuthFlow();
    const {
        email: emailAccount,
        password: passwordAccount,
        captcha: captchaAccount,
        timeExpire: expireTimeOTP,
        policies,
    } = registration;

    const interval = useRef(null);
    const [timerValue, setTimerValue] = useState(0);
    const [stateCompRender, setStateCompRender] = useState(componentRender ? componentRender : COMPONENT_RENDER.OTP);
    const [username, setUserName] = useState('');
    const [name, setName] = useState('');
    const [imageSource, setImageSource] = useState('');
    const [randomColor, setRandomColor] = useState('');
    const dispatch = useDispatch();
    const regexSpecialCharacter = /[^a-zA-Z0-9]+/g;
    const { openDialog } = useDialog()
    const [needAcceptShareInfo, setNeedAcceptShareInfo] = useState(false);
    const [shareInfo, setShareInfo] = useState();

    const verifyOTP = (email, code, page = "register") => {
        return apiManagerUser.verifyOTP(email, page, code);
    }

    const _register = () => {
        return apiManagerUser.register({
            email: emailAccount,
            password: passwordAccount,
            // name: e.name,
            name: '',
            username: username?.trim(),
            captcha: captchaAccount,
            randomColor: randomColor
        });
    };

    const linkAccount = (_shareInfo) => {
        return apiManagerUser.linkAccountSSO(username, passwordAccount, _shareInfo ? _shareInfo : shareInfo);
    }

    const sendOTP = (email, page) => {
        return apiManagerUser.sendOTP(email, page, undefined, undefined, 1, policies)
    }

    const handleSubmitVerifyOtp = () => {
        verifyOTP(emailAccount, otp)
            .then(res => {
                if (res?.data?.emailInfo === "EMAIL_EXIST") {
                    setStateCompRender(COMPONENT_RENDER.REGISTER_EMAIL_SAME_SSO);
                    setUserName(res?.data?.username);
                    setImageSource(res?.data?.images);
                    setName(res?.data?.name);
                } else {
                    setStateCompRender(COMPONENT_RENDER.REGISTER_EMAIL_NO_SSO)
                    let indexTextBeforeEmail = emailAccount?.indexOf('@');
                    let textBeforeEmail = emailAccount?.slice(0, indexTextBeforeEmail)?.replace(regexSpecialCharacter, "");
                    setUserName(textBeforeEmail);
                    setRandomColor(randomColorFunc());
                }
            })
            .catch(error => {
                if (error?.response?.data?.data === "OTP max retry") {
                    toastError(t('toast.maxVerifyOtp'));
                }
                if (error?.response?.data?.data === "SSO FAILED") {
                    toastError(t('toast.invalidOtp'));
                };;
                if (error?.response?.data?.data === "OTP used") toastError(t('toast.usedOtp'));
            })
    }

    const handleSubmitCreateAccount = async () => {
        _register()
            .then((result) => {
                if (result.status === 200) {
                    dispatch(establishSession({ accessToken: result?.data?.accessToken, refreshToken: result?.data?.refreshToken }));
                    clearRegistrationFlow();
                    navigate(`${PATH_ROOT}/profile-user`)
                    toastSuccess(t('toast.registerSuccess'));
                }
            })
            .catch((error) => {
                if (error?.response?.data?.detail_error === 'Captcha is invalid!') {
                    toastError(t('toast.captchaIsWrong'));
                } else if (error?.response?.data?.detail === 'ER_POLICY_PASSWORD') {
                    toastError(
                        t('validate.pwdRule', {
                            pwdMinLength: error.response.data.policy.password_min_length,
                            pwdMaxLength: error.response.data.policy.password_max_length,
                            policyNumber: error.response.data.policy.password_number,
                            policySpecial: error.response.data.policy.password_special,
                            policyUppercase: error.response.data.policy.password_uppercase,
                        }),
                    );
                } else if (error?.response?.data?.detail?.includes('existed')) {
                    toastError(t('toast.usernameIsExist'));
                } else {
                    toastError(t('toast.processError'));
                }
            });
    }

    const handleSubmitLinkAccount = () => {
        linkAccount()
            .then(result => {
                if (result?.data) {
                    if (result?.data?.error === "PI_SHARE_NOT_ALLOW") {
                        setNeedAcceptShareInfo(true);
                    } else {
                        dispatch(establishSession({ accessToken: result?.data?.accessToken, refreshToken: result?.data?.refreshToken }));
                        clearRegistrationFlow();
                        toastSuccess(t('toast.link-success'))
                        navigate(`${PATH_ROOT}/profile-user`)
                    }
                }
            })
            .catch(error => {
                toastError('Có lỗi xảy ra. Vui lòng thử lại.')
            })
    }
    const handleResendOtp = () => {
        sendOTP(emailAccount, "register")
            .then(r => {
                toastSuccess(t('toast.sendOTPSuccess'));
                updateRegistrationFlow({ timeExpire: r.timeExpire });
                setOtp('');
            })
            .catch(error => {
                if (error?.response?.data?.detail === ERROR.MAX_FORGOT_ACCOUNT) {
                    toastError(t('auth.ERROR.MAX_FORGOT_ACCOUNT'))
                } else if (error?.response?.data?.detail === ERROR.MAX_FORGOT_DEVICE) {
                    toastError(t('auth.ERROR.MAX_FORGOT_DEVICE'))
                } else if (error?.response?.data?.detail === ERROR.NO_EMAIL) {
                    toastError(t('auth.ERROR.NO_EMAIL'));
                    clearRegistrationFlow();
                    navigate(`${PATH_ROOT}/auth/register`);
                } else toastError(t(TOAST_DEFAULT.ERROR));

            });
    }

    const getLocalizedDurationFormatter = (duration) => {
        // if (moment.duration(duration).format('h') !== '0') {
        //     return moment.duration(duration).format('h:mm:ss');
        // }
        if (duration <= 0) {
            return '00:00';
        }

        return moment.unix(duration).format('mm:ss');
    }

    const setStateFromUTC = (currentTimeUTC, expireTimeUTC) => {
        if (!currentTimeUTC || !expireTimeUTC) {
            return;
        }

        if (expireTimeUTC < currentTimeUTC) {
            setTimerValue("00:00")
            return;
        }

        const durationUTC = expireTimeUTC - currentTimeUTC;

        const localizedTime = getLocalizedDurationFormatter(durationUTC);

        setTimerValue(localizedTime)
    }

    const startTimer = () => {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = '';
        }
        setStateFromUTC(moment().unix(), expireTimeOTP);

        interval.current = setInterval(() => {
            setStateFromUTC(moment().unix(), expireTimeOTP);
        }, 1000)
    }

    useEffect(() => {
        // if(stateCompRender === COMPONENT_RENDER.REGISTER_EMAIL_SAME_SSO) {
        //     openDialog(DialogAcceptPolicy)
        // }
        if (needAcceptShareInfo) {
            openDialog(DialogAcceptPolicy, {
                onAction: (policies) => {
                    setShareInfo(policies);
                    linkAccount(policies)
                        .then(result => {
                            if (result?.data) {
                                dispatch(establishSession({ accessToken: result?.data?.accessToken, refreshToken: result?.data?.refreshToken }));
                                clearRegistrationFlow();
                                toastSuccess(t('toast.link-success'))
                                navigate(`${PATH_ROOT}/profile-user`)
                            }
                        })
                        .catch(error => {
                            toastError('Có lỗi xảy ra. Vui lòng thử lại.')
                        })
                },
                onReject: () => { clearRegistrationFlow(); toastError(t('toast.error.title.loginError'), t('toast.error.content.sharingInfo'), { autoClose: 5000 }); navigate(`${PATH_ROOT}/login`) }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needAcceptShareInfo])

    useEffect(() => {
        if (expireTimeOTP) {
            startTimer();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expireTimeOTP])

    useEffect(() => () => {
        if (interval.current) {
            clearInterval(interval.current);
        }
    }, []);

    useEffect(() => {
        if (username?.length === 0) {
            const randomColorBg = randomColorFunc();
            setRandomColor(randomColorBg);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username]);

    useEffect(() => {
        if (!emailAccount || !passwordAccount) {
            navigate(`${PATH_ROOT}/auth/register`, { replace: true });
        } else if (params.get('refreshEnter')) {
            params.delete('refreshEnter');
            setSearchParams(params);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailAccount])

    return (
        <div className="register-email-container">
            <div className='drop-down-language'>
                <LanguageCC />
            </div>
            <div style={{ position: "relative", width: '100%', cursor: 'pointer' }} onClick={() => window.open(URL_LANDING_PAGE)}>
                <img alt='logo' style={{ position: 'absolute', marginBottom: '0px' }} className="logo-register-img" src={require('../../../assets/img/logo_020823.svg').default}></img>
            </div>
            <div style={{ width: '100%' }}>
                <div className="register-email-body">
                    <div className="register-email-image">
                        <div className="register-email-body-left">
                            <AppInfo />
                            {
                                stateCompRender === COMPONENT_RENDER.OTP
                                    ?
                                    <img
                                        alt='alt-img'
                                        className=""
                                        width="90%"
                                        src={require('../../../assets/img/Authentication_2.svg').default}
                                    ></img>
                                    : (
                                        stateCompRender === COMPONENT_RENDER.REGISTER_EMAIL_SAME_SSO
                                            ?
                                            <img
                                                alt='alt-img'
                                                className=""
                                                width="90%"
                                                src={require('../../../assets/img/link_account.svg').default}
                                            ></img>
                                            :
                                            <img
                                                alt='alt-img'
                                                className=""
                                                width="90%"
                                                src={require('../../../assets/img/left_content_1.svg').default}
                                            ></img>
                                    )
                            }
                        </div>
                    </div>
                    <div className="register-email-dialog">
                        <div className="form-register-container">
                            <div className="form-register-body">
                                {
                                    stateCompRender === COMPONENT_RENDER.OTP
                                        ?
                                        <OTPRegister otp={otp} setOtp={setOtp} onSubmit={handleSubmitVerifyOtp} timerValue={timerValue} emailAccount={emailAccount} resendOtp={handleResendOtp} />
                                        : (
                                            stateCompRender === COMPONENT_RENDER.REGISTER_EMAIL_SAME_SSO
                                                ?
                                                <RegisterEmailSameSSO name={name} username={username} emailAccount={emailAccount} imageSource={imageSource} onClickSubmit={handleSubmitLinkAccount} />
                                                :
                                                <RegisterEmailNoSSO emailAccount={emailAccount} username={username} setUserName={setUserName} onClickSubmit={handleSubmitCreateAccount} randomColor={randomColor} />
                                        )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterAuthentication />
        </div>
    );
}
